import React from 'react'
import Header from '../../sharedcomponents/header/Index'
import SubNav2 from '../../sharedcomponents/header/SubNav2'
import TxtIntro1 from '../../sharedcomponents/TextIntro/TxtIntro1'
import Album from '../../components/gallery/album'
import ParallaxOtherPages from '../../sharedcomponents/parallaxOtherPages/parallaxOtherPages.js';
import {imgHome7} from '../../sharedcomponents/ImageScope';
import Footer from '../../sharedcomponents/footer/Index.js';

import './index.css'
export default function GalleryPhotos(){
  return(
    <>
      <div style={{maxWidth:'1920px'}}>
        <Header galleryActive={"active"}/>
        <SubNav2/>
        <ParallaxOtherPages
          parallaxOtherPages_bg={imgHome7}
          parallaxOtherPages_title="Nossa Galeria."
          parallaxOtherPages_desc="Trabalhos, serviços e muito mais..."
          // parallaxOtherPages_txt="As fotos dos nossos trabalhos e serviços."
        />
        <br/>
        <TxtIntro1
           TxtIntro_title={"Conheça mais sobre os  nossos trabalhos feitos."}
           TxtIntro_description={"Vê os trabalhos realizado pela HS Design, serviços prestados e os nossos produtos."}
        />
        <Album/> 
        <Footer/>
      </div>
    </>
  );
}